import { createAction } from "../../utils/reducer/reducer.util";
import { CATEGORIES_ACTION_TYPES } from "./category.types";
// import { getCateogiresAndDocuments } from "../../utils/firebase/firebase.util";




export const fetchCategoriesStart=()=> createAction(CATEGORIES_ACTION_TYPES.FETCH_CATEGORIES_START)

export const fetchCategoriesSuccess=(categoriesArray)=> createAction(CATEGORIES_ACTION_TYPES.FETCH_CATEGORIES_SUCCESS,categoriesArray)

export const fetchCategoriesFailed=(error)=> createAction(CATEGORIES_ACTION_TYPES.FETCH_CATEGORIES_FAILED,error)


// export const fetchCategoriesAsync =()=>async(dispatch)=>{
//     dispatch(fetchCategoriesStart())
//     try{
//         const categoriesArray=await getCateogiresAndDocuments('categories')
//        dispatch( fetchCategoriesSuccess(categoriesArray))
//     } catch(error){
//         dispatch(fetchCategoriesFailed(error))
//     }
    

// }